export default function($) {

  // Registration form:
  var role_checkboxes = $('.js-role_checkboxes')

  if (role_checkboxes.length) {
    registration_form_ui();

    $('.js-role_checkboxes input:radio').change(function () {
      registration_form_ui();
    })
  }

  function registration_form_ui() {
    var radio_role_student = $('.js-radio-role-client_student');
    var radio_role_eps_member = $('.js-radio-role-client_eps_member');
    var input_eps_number_block = $('.js-eps-number-block');
    var input_eps_granted_block = $('.js-eps-granted-block');

    // we do nothing if the selector is not found
    if (!radio_role_student.length || !radio_role_eps_member.length) {
      return;
    }

    if (radio_role_student.prop('checked')) {
      input_eps_number_block.addClass('hidden-visually');
      input_eps_granted_block.removeClass('hidden-visually');
    } else if (radio_role_eps_member.prop('checked')) {
      input_eps_number_block.removeClass('hidden-visually');
      input_eps_granted_block.addClass('hidden-visually');
    } else {
      input_eps_number_block.addClass('hidden-visually');
      input_eps_granted_block.addClass('hidden-visually');
    }
  }

  // Additional Accompanying form:
  var has_accompanying_checkbox = $('.js-has-accompanying-checkbox')

  if (has_accompanying_checkbox.length) {
    additional_accompanying_form_ui();

    has_accompanying_checkbox.change(function () {
      additional_accompanying_form_ui();
    })
  }

  function additional_accompanying_form_ui() {
    var details_fieldset = $('.js-accompanying-details');
    var optional_transportations_fieldset = $('.js-accompanying-optional-transportations');
    var optional_lunches_fieldset = $('.js-accompanying-optional-lunches');
    var social_events_fieldset = $('.js-accompanying-social-events');
    var accompanying_visits_fieldset = $('.js-accompanying-visits');

    if (has_accompanying_checkbox.prop('checked')) {
      details_fieldset.removeClass('hidden-visually');
      optional_transportations_fieldset.removeClass('hidden-visually');
      optional_lunches_fieldset.removeClass('hidden-visually');
      social_events_fieldset.removeClass('hidden-visually');
      accompanying_visits_fieldset.removeClass('hidden-visually');
    } else {
      details_fieldset.addClass('hidden-visually');
      optional_transportations_fieldset.addClass('hidden-visually');
      optional_lunches_fieldset.addClass('hidden-visually');
      social_events_fieldset.addClass('hidden-visually');
      accompanying_visits_fieldset.addClass('hidden-visually');
    }
  }

  // Order form nav on mobile

  var step_list_button = $('.js-step-button');

  step_list_button.click(function () {
    if(step_list_button.is(":visible")) {
      $('.js-step-list').slideToggle(90);
      $(this).toggleClass('border-b');
      $(this).toggleClass('c-step-list__item--button--active');
    }
  });

  $(window).resize( function() {
    if(step_list_button.is(":visible")) {
      $('.js-step-list').css('display', 'none');
    } else {
      $('.js-step-list').css('display', 'flex');
    }
  });
}
